<i18n>
{
	"en": {
		"noOrdersFound": "No orders found",
		"orderNumber": "Order",
		"etd": "Etd/Atd",
		"from": "From",
		"to": "To"
	},
	"no": {
		"noOrdersFound": "Fant ingen oppdrag",
		"orderNumber": "Oppdrag",
		"etd": "Eta/Ata",
		"from": "Fra",
		"to": "Til"
	}
}
</i18n>

<template>
	<div>
		<t-grid
			v-if="generatedOrders.length"
			ref="grid"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			:items="generatedOrders"
			class="menu-grid"
			:selectableMode="['row']"
			selectable
			@selected="onRowsSelected"
			@rowDoubleClick="showOrder"
			@enter="showOrder"
		>
			<template #orderNumber="{ item }">
				{{ item.orderNumber }}
			</template>
			<template #despatchParty="{ item }">
				<div style="height: 16px;">{{ item.despatchParty.name }}</div>
				<div class="grid-cell-sub-line">{{ item.despatchParty.street }}, {{ item.despatchParty.postalCode }} {{ item.despatchParty.postalPlace }}</div>
			</template>
			<template #deliveryParty="{ item }">
				<div style="height: 16px;">{{ item.deliveryParty.name }}</div>
				<div class="grid-cell-sub-line">{{ item.deliveryParty.street }}, {{ item.deliveryParty.postalCode }} {{ item.deliveryParty.postalPlace }}</div>
			</template>
			<template #disconnect="{ item }">
				<t-icon-button
					icon="trash"
					intent="danger"
					type="bp"
					appearance="minimal"
					@click="disconnectOrder(item.id)"
				/>
			</template>
		</t-grid>
		<t-no-content-panel
			v-else
			:text="$t('noOrdersFound')"
			style="height: 500px"
			icon="order"
		/>
	</div>
</template>

<script>
import { mapState, mapMutations } from '../store/orderTemplates.store';
import { displayDateFormat, storageDateFormat, displayDateFormatter, eventBus, dateExists } from '@/core';
import moment from 'moment';

export default {
	name: 'GeneratedOrders',
	data() {
		return {
			defaultColumnDefinition: { resizable: true },
			rowsSelected: 0
		};
	},
	computed: {
		...mapState([ 'generatedOrders', 'templateDetails' ]),
		columnDefinitions() {
			return [
				{
					field: 'orderNumber',
					displayName: this.$t('orderNumber'),
					width: 80,
					type: 'number',
					comparableValueGetter: (item) => Number(item.orderNumber),
				},
				{
					field: 'etd',
					displayName: this.$t('etd'),
					valueGetter: ({ etd, atd }) => displayDateFormatter(atd && 'date' in atd ? atd.date : etd.date),
					width: 90,
					resizable: false,
					type: 'date',
					dateFormat: displayDateFormat,
					comparableValueGetter: ({ etd, atd }) => moment(atd && 'date' in atd ? atd.date : etd.date, storageDateFormat).toISOString(),
					cellClass(item) { return dateExists(item.atd) ? 'grid-cell-bold' : 'grid-cell-light'; }
				},
				{
					field: 'despatchParty',
					displayName: this.$t('from'),
					comparableValueGetter: ({ despatchParty }) =>  this.addressGetter(despatchParty),
					type: 'address',
					minWidth: 125
				},
				{
					field: 'deliveryParty',
					displayName: this.$t('from'),
					comparableValueGetter: ({ deliveryParty }) =>  this.addressGetter(deliveryParty),
					type: 'address',
					minWidth: 125
				},
				{
					field: 'disconnect',
					displayName: '',
					width: 40,
					filterable: false,
					resizable: false
				}
			];
		}
	},
	methods: {
		...mapMutations([ 'updateTemplateDetails', 'setGeneratedTrips' ]),
		addressGetter(party) {
			if (!party) return '';
			if (typeof party === 'string') {
				return party;
			} else {
				return `${party.name} ${party.street} ${party.postalCode} ${party.postalPlace}`;
			}
		},
		onRowsSelected(ids) {
			this.rowsSelected = ids.length;
		},
		showOrder(orderId) {
			// let id = undefined;
			// if (orderId) {
			// 	id = orderId;
			// } else {
			// 	let [order] = this.$refs.grid.getSelectedItems();
			// 	if (!order) return;
			// 	id = order.id;
			// }

			// this does not work anymore. Open order in new tab?
			// setTimeout( () => eventBus.$emit('toggleNewOrderModal', true), 15);
			// eventBus.$emit('setEditOrder', id);
		},
		disconnectOrder(orderId) {
			let ids = this.templateDetails.generatedOrders;
			ids.splice(ids.indexOf(orderId), 1);
			this.updateTemplateDetails({ key: 'generatedTrips', value: ids });

			let orders = this.generatedOrders;
			orders.splice(this.generatedOrders.findIndex( (order) => order.id === orderId ), 1);
			this.setGeneratedOrders(orders);
		}
	}
};
</script>

<style lang="scss" scoped>

.menu-grid {
	margin-top: 20px;
	height: 500px;
	width: 100%;
}

</style>